export function downloadCertificate(options: {
  studentName: string
  courseTitle: string
  completedAt: string
}) {
  const canvas = document.createElement('canvas')
  canvas.width = 1400
  canvas.height = 990
  const ctx = canvas.getContext('2d')
  if (!ctx) return

  ctx.fillStyle = '#F4EFE6'
  ctx.fillRect(0, 0, canvas.width, canvas.height)

  ctx.strokeStyle = '#1C1915'
  ctx.lineWidth = 2
  ctx.strokeRect(48, 48, canvas.width - 96, canvas.height - 96)
  ctx.strokeRect(64, 64, canvas.width - 128, canvas.height - 128)

  ctx.fillStyle = '#9C4A2A'
  ctx.font = '500 22px Georgia, serif'
  ctx.textAlign = 'center'
  ctx.fillText('HFCursos', canvas.width / 2, 160)

  ctx.fillStyle = '#1C1915'
  ctx.font = '500 18px Georgia, serif'
  ctx.fillText('CERTIFICADO DE CONCLUSIÓN', canvas.width / 2, 220)

  ctx.beginPath()
  ctx.moveTo(520, 248)
  ctx.lineTo(880, 248)
  ctx.strokeStyle = '#C4B8A5'
  ctx.lineWidth = 1
  ctx.stroke()

  ctx.font = '400 20px Georgia, serif'
  ctx.fillStyle = '#5C564C'
  ctx.fillText('Se certifica que', canvas.width / 2, 340)

  ctx.fillStyle = '#1C1915'
  ctx.font = '500 54px Georgia, serif'
  ctx.fillText(options.studentName, canvas.width / 2, 420)

  ctx.font = '400 22px Georgia, serif'
  ctx.fillStyle = '#5C564C'
  ctx.fillText('ha completado el curso', canvas.width / 2, 490)

  ctx.fillStyle = '#1C1915'
  ctx.font = '500 36px Georgia, serif'
  ctx.fillText(options.courseTitle, canvas.width / 2, 560)

  const date = new Date(options.completedAt)
  const formatted = Number.isNaN(date.getTime())
    ? options.completedAt
    : date.toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })

  ctx.font = '400 18px Georgia, serif'
  ctx.fillStyle = '#5C564C'
  ctx.fillText(`Madrid, ${formatted}`, canvas.width / 2, 680)

  ctx.beginPath()
  ctx.moveTo(520, 780)
  ctx.lineTo(880, 780)
  ctx.strokeStyle = '#1C1915'
  ctx.stroke()

  ctx.font = '400 16px Georgia, serif'
  ctx.fillStyle = '#1C1915'
  ctx.fillText('Helena Ferrer · Dirección académica', canvas.width / 2, 812)

  const link = document.createElement('a')
  link.download = `certificado-hfcursos-${options.courseTitle.toLowerCase().replace(/\s+/g, '-')}.png`
  link.href = canvas.toDataURL('image/png')
  link.click()
}
